import { NoTranslate } from "@/core/components/ui/no-translate";
import { DEFAULT_CURRENCY, formatMinorAmount } from "@/core/utils/func/money-minor";

/**
 * Affichage canonique d'un montant API (entier, unité mineure — guide §4.3) :
 * formatage dans la langue courante + `NoTranslate` (règle notranslate sur
 * les données financières).
 */
export function AmountMinor({
  amountMinor,
  currency = DEFAULT_CURRENCY,
  className,
}: {
  amountMinor: number | null | undefined;
  currency?: string;
  className?: string;
}) {
  return (
    <NoTranslate as="span" className={className}>
      {formatMinorAmount(amountMinor, currency)}
    </NoTranslate>
  );
}
